import React, { Component } from 'react'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class ContactPopupForm extends Component {

  state = {
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    isSubmitting: false,
  }

  constructor(props) {
    super(props)
    this.form = React.createRef()
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    // Disable the submit button
    this.setState({ isSubmitting: true })

    // TODO: confirm if the following endpoint is used in all pages
    // https://zapier.com/editor/190212665/published/190212665
    fetch("https://hooks.zapier.com/hooks/catch/2181815/3uh7ou3/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        ...this.state,
      }),
    })
      .then(() => {
        this.setState({ result: "success" })
      })
      .catch(error => this.setState({ result: "fail", msg: error }))
      .finally(() => {
        // Re-enable the submit button after the request completes
        this.setState({ isSubmitting: false })
      });
  }

  render() {

    let { formIntro, download } = this.props
    let { result } = this.state

    let props = {
      ref: this.form,
      name: 'contact',
      className: 'form form--contact',
      onSubmit: this.handleSubmit,
    }

    if (result === 'success') {
      return (
        <div className='popup__success'>
          <p>Thank you for providing your details. Please keep an eye on your inbox for the latest market insights.</p>
          <a className='btn' href={download} target='_blank' rel='noopener noreferrer' download>Download</a>
        </div>
      )
    }

    return (

      <form {...props}>

        { formIntro && <p>{formIntro}</p> }

        { this.state.msg && <div className='error'>{ this.state.msg }</div> }

        <div className='form__row form__row--double'>
          <div className='form__col'>
            <label htmlFor='first-name-field'> First Name </label>
            <input type='text' name='firstname' id='first-name-field' className='form__input' onChange={this.handleChange} required />
          </div>
          <div className='form__col'>
            <label htmlFor='first-name-field'> Last Name </label>
            <input type='text' name='lastname' id='first-name-field' className='form__input' onChange={this.handleChange} required />
          </div>
        </div>
        <div className='form__row'>
          <div className='form__col'>
            <label htmlFor='email-field'> Email address </label>
            <input type='text' name='email' id='email-field' className='form__input' onChange={this.handleChange} required />
          </div>
        </div>
        <div className='form__row'>
          <div className='form__col'>
            <label htmlFor='email-field'> Contact Number </label>
            <input type='text' name='phone' id='phone-field' className='form__input' onChange={this.handleChange} required />
          </div>
        </div>

        <div className='form__row form__row--submit'>
          <button type='submit' className='btn btn--border btn--download-insights'  disabled={this.state.isSubmitting}>
            Download Now
            <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.4163 5.3336L6.83354 8.9164V0.5H5.16636V8.9164L1.58356 5.3336L0.416382 6.5L5.99998 12.0836L11.5836 6.5L10.4163 5.3336Z" fill="white"/>
              <path d="M1.41638 13.8336H10.5828V15.5H1.41638V13.8336Z" fill="white"/>
            </svg>
          </button>
        </div>

      </form>
    )
  }
}

export default ContactPopupForm